import { ButtonControl } from "@/Common/Components/Buttons/ButtonControl";
import ButtonGroup from "@/Common/Components/Buttons/ButtonGroup";
import { Popup } from "@/Common/Components/Modals/Popup";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";

interface IDoubleBookingDialog {
    cancelClickOp: number;
    continueClickOp: number;
}

class DoubleBookingDialog extends React.Component<IDoubleBookingDialog, never> {
    public render(): JSX.Element {
        return (
            <Popup cssClass="double-booking" title={cacheStore.GetString("MessageDoubleBookingTitleLabel")} closeTarget={LocalOperations.Calendar.AppointmentEdit_DoubleBooking_Cancel}>
                <div className="p-body">
                    <div className="row">
                        <div className="col-lg-12">
                            <p>{cacheStore.GetString("MessageDoubleBookingLabel")}</p>
                            <p>{cacheStore.GetString("MessageDoubleBooking2Label")}</p>
                        </div>
                    </div>
                </div>
                <div className="p-footer flex-display flex-end">
                    <ButtonGroup>
                        <ButtonControl
                            variant="neutral"
                            onClick={this.OnCancelClick.bind(this)}
                            label={cacheStore.GetString("CancelLabel")}
                        />
                        <ButtonControl
                            variant="brand"
                            onClick={this.OnContinueClick.bind(this)}
                            label={cacheStore.GetString("ContinueLabel")}
                            dataCy="doubleBookingDialog-continue-button"
                        />
                    </ButtonGroup>
                </div>
            </Popup>
        );
    }

    public OnCancelClick(): void {
        var operation = new LocalEvent(this.props.cancelClickOp);
        LocalEventDispatcher.dispatch(operation);
    }

    public OnContinueClick(): void {
        var operation = new LocalEvent(this.props.continueClickOp);
        LocalEventDispatcher.dispatch(operation);
    }
}

export { DoubleBookingDialog };
